module.exports = __webpack_public_path__ + "img/dark_logo.31788786.png";